import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { GridToolbar } from '@mui/x-data-grid';
import { Typography, Box } from '@mui/material';

function DataTable({ data, title }) {
  // Ensure data is defined and has the expected structure
  const headers = data?.headers || [];
  const rows = data?.rows || [];

  // Prepare columns for DataGrid
  const columns = headers.map((header, index) => ({
    field: `col${index}`, // Unique field name for each column
    headerName: header,
    flex: 1, // Adjust column width dynamically
    sortable: true, // Enable sorting
  }));

  // Prepare rows for DataGrid
  const formattedRows = rows.map((row, rowIndex) => {
    const rowData = { id: rowIndex }; // Add a unique `id` field for each row
    row.forEach((cell, cellIndex) => {
      rowData[`col${cellIndex}`] = cell; // Map each cell to its corresponding column
    });
    return rowData;
  });

  return (
    <Box>
      {title && (
        <Typography
          variant="subtitle2"
          sx={{ mb: 1, fontWeight: 'medium' }}
        >
          {title}
        </Typography>
      )}

      <div style={{ height: 400, width: '100%' }}>
        <DataGrid
          rows={formattedRows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          slots={{ toolbar: GridToolbar }}
        />
      </div>
    </Box>
  );
}

export default DataTable;
